import { render } from "./baarbari.vue?vue&type=template&id=ae847664"
import script from "./baarbari.vue?vue&type=script&lang=js"
export * from "./baarbari.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__